import React from 'react';

import './HorizontalRule.less';
import clsx from 'clsx';

const HorizontalRule = ({ className }) => <hr className={clsx('horizontal-rule', className)} />;

export default HorizontalRule;
